// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rds-font-body.rds-text-3xs.rds-select-auto.rds-flex.rds-justify-center.rds-items-center.rds-rounded-full.rds-mx-2xs {
    display: initial !important;
}

#icon3 {
    display: inline-flex !important;
}

#icon2 {
    display: inline-flex !important;
}

.in-iframe {
    zoom: 1.25 !important;
}`, "",{"version":3,"sources":["webpack://./src/features/transaction-signing/containers/HardToken.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".rds-font-body.rds-text-3xs.rds-select-auto.rds-flex.rds-justify-center.rds-items-center.rds-rounded-full.rds-mx-2xs {\n    display: initial !important;\n}\n\n#icon3 {\n    display: inline-flex !important;\n}\n\n#icon2 {\n    display: inline-flex !important;\n}\n\n.in-iframe {\n    zoom: 1.25 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
